import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["QuarkleLogo","QuarkleWordmark"] */ "/vercel/path0/src/components/Brand.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Buttons/LaunchButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Home/Features.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Home/HeaderBackgroundImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionThree","SectionFour","SectionFive","SectionSix"] */ "/vercel/path0/src/components/Home/LandingPage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContainerScroll"] */ "/vercel/path0/src/components/ui/container-scroll-animation.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/Home.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/Footer.css");
